export default "__VITE_ASSET__BJmnZVf5__"